import { DEFAULT_RULES_BANK } from '../constants/competition';

export const normalizeRulesList = (list, fallbackSource = 'club') => {
  if (!Array.isArray(list)) return [];
  const seen = new Set();
  return list
    .map((r, idx) => {
      if (!r || typeof r !== 'object') return null;
      const title = String(r.title || '').trim();
      if (!title) return null;
      const baseId = String(r.id || '').trim() || title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      const id = baseId || `rule-${idx + 1}`;
      const dedupeId = seen.has(id) ? `${id}-${idx + 1}` : id;
      seen.add(dedupeId);
      return {
        id: dedupeId,
        title,
        detail: String(r.detail || '').trim(),
        source: r.source === 'site' || r.source === 'club' ? r.source : fallbackSource,
      };
    })
    .filter(Boolean);
};

export const mergeCompDefaults = (base = {}, overrides = {}) => ({
  ...base,
  ...overrides,
  rulesBank: {
    ...DEFAULT_RULES_BANK,
    ...((base && base.rulesBank) || {}),
    ...((overrides && overrides.rulesBank) || {}),
  },
  appliedRules: normalizeRulesList((overrides && overrides.appliedRules) || (base && base.appliedRules) || [], 'club'),
});
